import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/auth.service';
import { UserDataService } from 'src/app/features/user-data.service';
import { MailCenterService } from 'src/app/mail-center/mail-center.service';

@Component({
  selector: 'app-record-invention',
  templateUrl: './record-invention.component.html',
  styleUrls: ['./record-invention.component.css']
})
export class RecordInventionComponent implements OnInit {
  inventionStatus:any=[];
  aslan=false;
  inventorShareCounter=0;
  companyShareCounter=0;
  status:string=""; //deciding the shown material
  keyCode:any;
  inventionDetailData!:any;
  companyData:any=[]; inventorData:any=[];attorneyData:any=[]; rdCenter:any;project:any;
  inventionName:string="";
  inventionDate:string="";
  documentNumber:string="";
  visible=false;
  token:string="";
  visibleCompany=false;
  visibleInventor=false;
  visibleAttorney=false;
  CompanyAdded=false;
  inventorAdded=false;
  attorneyAdded=false;
  record:string="";
  userWithToken:any;
  companies:any;
  users:any;
  attornies:any;
  error:string="";
  docLink:any=[];
  notes:any;
  patentInfo:any;
  inventor:Array<{name: string, adress: string, mail:string, identity:string, status:string, share:number, inventorsCompany:string }>=[];
  company:Array<{name: string, adress: string,  identity:string,  share:number }>=[];
  attorney:Array<{name: string, adress: string,  identity:string }>=[];
  searchText:any;
  inventionRecord!:FormGroup;
  loggedUser="";
  constructor(private userData:UserDataService, private auth:AuthService, private mailService:MailCenterService,private route:Router, private activatedRoute:ActivatedRoute) {

   }


  /*ngAfterContentInit(): void {
    this.loggedUser=this.auth.userMail;
    this.keyCode=this.userData.key;
    this.userData.inventionDetail(this.keyCode).
    subscribe(res=>
      {//console.log(res);
      this.inventionDetailData=res;
      this.companyData=this.inventionDetailData[0].hasOwnProperty('CompanyData') ? this.companyData= this.inventionDetailData[0].CompanyData : this.companyData=[];
      //
      this.inventorData=this.inventionDetailData[0].hasOwnProperty('inventorData') ? this.inventorData= this.inventionDetailData[0].inventorData : this.inventorData=[];
      //
      this.inventionName=this.inventionDetailData[0].inventionName;
      this.documentNumber=this.inventionDetailData[0].documentNumber;
      this.inventionDate=this.inventionDetailData[0].inventionDate;
      this.inventionStatus=this.inventionDetailData[0].status;
      this.docLink=this.inventionDetailData[0].hasOwnProperty('docLink') ? this.docLink= this.inventionDetailData[0].docLink : this.docLink=[];
      this.patentInfo=this.inventionDetailData[0].hasOwnProperty('patentInfo') ? this.patentInfo= this.inventionDetailData[0].patentInfo : this.patentInfo=[];
      //this.status=this.inventionDetailData[0].status.slice(-1)[0];
      this.status=this.inventionDetailData[0].status.slice(-1)[0].status;
      this.visible=true;
      //console.log(this.companyData, this.inventorData,this.inventionName);
      });
      //import companies
      this.userData.fetchCompany(this.token).subscribe(
       (res: any) => {
        if (!res) {
          this.record="There is no company found"
        } else {

        //console.log(res);
        this.userWithToken=res;
        this.companies = Object.keys(res).map((key) =>
        { return res[key] });

        this.companies.key = Object.keys(res).map((key) =>
        { return (key) });

        //console.log(this.companies);
        if (this.CompanyAdded==false) {
          this.company=this.companyData;
          this.CompanyAdded=true;
        }
        this.record=""
      }},err=>this.error=(err.statusText)
    );
    //import inventors
    this.userData.fetchInventor(this.token).subscribe(
      (res: any) => {
       if (!res) {
         this.record="Buluş Sahibi bulunamadı"
       } else {

       //console.log(res);
       this.userWithToken=res;
       this.users = Object.keys(res).map((key) =>
       { return res[key] });

       this.users.key = Object.keys(res).map((key) =>
       { return (key) });
       //console.log(this.inventorData.length, this.inventorData)
       if (this.inventorAdded==false) {
         this.inventor=this.inventorData;
         this.inventorAdded=true;
       }
       //console.log(this.users);
       this.record=""
     }},err=>this.error=(err.statusText)
   );
      }*/


      ngOnInit(): void {

        this.token=this.auth.token;
        this.loggedUser=this.auth.userMail;
        this.keyCode=this.userData.key;
        this.userData.inventionDetail(this.keyCode).
        subscribe(res=>

          {//console.log(res);
          this.inventionDetailData=res;
          this.companyData=this.inventionDetailData[0].hasOwnProperty('CompanyData') ? this.companyData= this.inventionDetailData[0].CompanyData : this.companyData=[];

          this.inventorData=this.inventionDetailData[0].hasOwnProperty('inventorData') ? this.inventorData= this.inventionDetailData[0].inventorData : this.inventorData=[];
          this.attorneyData=this.inventionDetailData[0].hasOwnProperty('AttorneyData') ? this.attorneyData= this.inventionDetailData[0].AttorneyData : this.attorneyData=[];
          this.project=this.inventionDetailData[0].project;
          this.rdCenter=this.inventionDetailData[0].rdCenter;
        //  this.companyData=[];
        //  this.inventorData=[];
         // this.attorneyData=[];
          this.inventionName=this.inventionDetailData[0].inventionName;
          this.documentNumber=this.inventionDetailData[0].documentNumber;
          this.inventionDate=this.inventionDetailData[0].inventionDate;
          this.inventionStatus=this.inventionDetailData[0].status;
          this.docLink=this.inventionDetailData[0].hasOwnProperty('docLink') ? this.docLink= this.inventionDetailData[0].docLink : this.docLink=[];
          this.patentInfo=this.inventionDetailData[0].hasOwnProperty('patentInfo') ? this.patentInfo= this.inventionDetailData[0].patentInfo : this.patentInfo=[];
          this.notes=this.inventionDetailData[0].hasOwnProperty('notes') ? this.notes= this.inventionDetailData[0].notes : this.notes="not yok";
          //this.status=this.inventionDetailData[0].status.slice(-1)[0];
          this.status=this.inventionDetailData[0].status.slice(-1)[0].status;
          this.visible=true;
          //console.log(this.companyData, this.inventorData,this.inventionName);
          });
          this.findInventor1();
        this.findAttorney1();
        this.findCompany1();
          //import companies

          this.userData.fetchCompany(this.token).subscribe(

           (res: any) => {
            if (!res) {
              this.record="There is no company found"
            } else {

            //console.log(res);
            this.userWithToken=res;
            this.companies = Object.keys(res).map((key) =>
            { return res[key] });

            this.companies.key = Object.keys(res).map((key) =>
            { return (key) });

            //console.log(this.companies);
            if (this.CompanyAdded==false) {
              this.company=this.companyData;
            //  this.CompanyAdded=true;
            }
            this.record=""
          }},err=>this.error=(err.statusText)
        );
        //import inventors
        this.userData.fetchInventor(this.token).subscribe(
          (res: any) => {
           if (!res) {
             this.record="Buluş Sahibi bulunamadı"
           } else {

           //console.log(res);
           this.userWithToken=res;
           this.users = Object.keys(res).map((key) =>
           { return res[key] });

           this.users.key = Object.keys(res).map((key) =>
           { return (key) });
           //console.log(this.inventorData.length, this.inventorData)
           if (this.inventorAdded==false) {
             this.inventor=this.inventorData;
             console.log(this.inventor);
             //this.inventorAdded=true;
           }
           //console.log(this.users);
           this.record=""
         }},err=>this.error=(err.statusText)
       );
       //import Attornies
       this.userData.fetchAttorney(this.token).subscribe(
        (res: any) => {
         if (!res) {
           this.record="Vekil kaydı bulunamadı"
         } else {

         //console.log(res);
         this.userWithToken=res;
         this.attornies = Object.keys(res).map((key) =>
         { return res[key] });

         this.attornies.key = Object.keys(res).map((key) =>
         { return (key) });
         console.log(this.attornies)
         if (this.attorneyAdded==false) {
           this.attorney=this.attorneyData;

           //this.inventorAdded=true;
         }
         //console.log(this.users);
         this.record=""
       }},err=>this.error=(err.statusText)
     );

          }



  getDetails() {

    this.keyCode=this.userData.key;
    this.userData.inventionDetail(this.keyCode).
    subscribe(res=>
      {//console.log(res);
      this.inventionDetailData=res;
      this.companyData=this.inventionDetailData[0].CompanyData;
      this.inventorData=this.inventionDetailData[0].inventorData;
      this.attorneyData=this.inventionDetailData[0].attorneyData;
      this.inventionName=this.inventionDetailData[0].inventionName;
      this.documentNumber=this.inventionDetailData[0].documentNumber;
      this.inventionDate=this.inventionDetailData[0].inventionDate;
      this.inventionStatus=this.inventionDetailData[0].status;

      //this.status=this.inventionDetailData[0].status.slice(-1)[0];
      this.status=this.inventionDetailData[0].status.slice(-1)[0].status;
      this.visible=true;
      //console.log(this.companyData, this.inventorData,this.inventionName);
      })
      }
  navigate() {this.route.navigate(['patentList/',this.inventionDetailData[0].documentNumber]);
  this.userData.getKey(this.keyCode);}

  deleteCompanies() {
    this.companyData=[];
    this.company=[];
    this.CompanyAdded=false;}
    deleteAttornies() {
      this.attorneyData=[];
      this.attorney=[];
      this.attorneyAdded=false;}
  deleteInventors() {
    this.inventorData=[];
    this.inventor=[];
    this.inventorAdded=false;
  }
  findInventor()   {
    this.visibleInventor=!this.visibleInventor;
    this.findInventor1();
  }
  findInventor1() { this.userData.fetchInventor(this.token).subscribe(
     (res: any) => {
      if (!res) {
        this.record="Buluş Sahibi bulunamadı"
      } else {

      //console.log(res);
      this.userWithToken=res;
      this.users = Object.keys(res).map((key) =>
      { return res[key] });

      this.users.key = Object.keys(res).map((key) =>
      { return (key) });
      //console.log(this.inventorData.length, this.inventorData)
      if (this.inventorAdded==false) {
        this.inventor=this.inventorData;
        //this.inventorAdded=true;
      }
      //console.log(this.users);
      this.record=""
    }},err=>this.error=(err.statusText)
  );
  }

  findCompany() {
      this.visibleCompany=!this.visibleCompany;
    this.findCompany1()}
      findCompany1() {
      this.userData.fetchCompany(this.token).subscribe(
       (res: any) => {
        if (!res) {
          this.record="Başvuru Sahibi bulunamadı"
        } else {

        //console.log(res);
        this.userWithToken=res;
        this.companies = Object.keys(res).map((key) =>
        { return res[key] });

        this.companies.key = Object.keys(res).map((key) =>
        { return (key) });

        //console.log(this.companies);
        if (this.CompanyAdded==false) {
          this.company=this.companyData;
         // this.CompanyAdded=true;
        }
        this.record=""
      }},err=>this.error=(err.statusText)
    );
    }
    findAttorney() {
      this.visibleAttorney=!this.visibleAttorney;
    this.findAttorney1()}
      findAttorney1(){
      this.userData.fetchAttorney(this.token).subscribe(
       (res: any) => {
        if (!res) {
          this.record="Vekil bulunamadı"
        } else {

        //console.log(res);
        this.userWithToken=res;
        this.attornies = Object.keys(res).map((key) =>
        { return res[key] });

        this.attornies.key = Object.keys(res).map((key) =>
        { return (key) });

        //console.log(this.companies);
        if (this.attorneyAdded==false) {
          this.attorney=this.attorneyData;
         // this.CompanyAdded=true;
        }
        this.record=""
      }},err=>this.error=(err.statusText)
    );
    }
    getInventor(i:number){
      // this.inventor.push({name:this.users[i].inventorName[0], adress:this.users[i].inventorAdress[0], mail: this.users[i].inventorMail[0]});
      this.visibleInventor=false;
      for (const element of this.users[i]) {
       this.inventor.push({name:element.inventorName, adress:element.inventorAdress, mail: element.inventorMail, identity:element.inventorIdentityNo, status:element.inventorStatus, inventorsCompany:element.inventorsCompany.name, share:0});
       this.inventorData=this.inventor
       console.log(this.inventor);

       this.inventorAdded=true;
      }
     }
    getCompany(i:number) {
      // this.inventor.push({name:this.users[i].inventorName[0], adress:this.users[i].inventorAdress[0], mail: this.users[i].inventorMail[0]});
      this.visibleCompany=false;
      //console.log(this.companies)
      for (const element of this.companies[i]) {
       this.company.push({name:element.CompanyName, adress:element.CompanyAdress,  identity:element.CompanyIdentityNo,  share:0});
       this.companyData=this.company;
       //console.log(this.company);

       this.CompanyAdded=true;


      }
     }
     getAttorney(i:number) {
      // this.inventor.push({name:this.users[i].inventorName[0], adress:this.users[i].inventorAdress[0], mail: this.users[i].inventorMail[0]});
      this.visibleAttorney=false;
      console.log(this.attornies)
      for (const element of this.attornies[i]) {
       this.attorney.push({name:element?.AttorneyName, adress:element?.AttorneyAdress,  identity:element?.AttorneyIdentityNo});
       this.attorneyData=this.attorney;
       console.log(this.attorneyData);

       this.attorneyAdded=true;


      }
     }

     checkValidity() {
      console.log(this.status)
      let companyShare=0;
      let inventorShare=0;
      this.companyData?.forEach((element: any) =>
      {companyShare=companyShare+element.share});
      this.inventorData?.forEach((element: any) =>
      {inventorShare=inventorShare+element.share});
      console.log(companyShare, inventorShare);
      if (this.companyData.length > 0 && this.inventorData.length > 0 && Math.round(companyShare)==100 && Math.round(inventorShare)==100) {return true} else {return false}
    /*  for (const element of this.companyData)
        {this.companyShareCounter=this.companyShareCounter+(+element.share) };
      for (const element of this.inventorData)
        {this.inventorShareCounter=this.inventorShareCounter+(+element.share) }
      console.log(this.companyShareCounter)
      console.log(this.inventorShareCounter)
      console.log(this.company,this.inventor);

      if(this.companyShareCounter==100 && this.inventorShareCounter==100 && this.CompanyAdded && this.inventorAdded){ console.log("eyw");
      this.inventorShareCounter=0; this.companyShareCounter=0; this.aslan=true; this.record="";
    } else {console.log("hu");
      this.inventorShareCounter=0; this.companyShareCounter=0;  this.record="."};
*/
      } ;
      onSubmit()  {
        this.visible=false;
        this.documentNumber=this.documentNumber.toLowerCase();
        this.inventionName=this.inventionName.toLowerCase();
        this.notes=this.notes.toLowerCase();
        this.documentNumber=this.documentNumber.replace('Ş','S')
        .replace('Ç','C').replace('Ğ','G').replace('İ','I').replace('Ö','O').replace('Ü','U')
        .replace('ç','c').replace('ğ','g').replace('ö','o').replace('ü','u').replace('ş','s').replace('Ş','S')
        .replace('Ç','C').replace('Ğ','G').replace('İ','I').replace('Ö','O').replace('Ü','U')
        .replace('ç','c').replace('ğ','g').replace('ö','o').replace('ü','u').replace('ş','s').replace('Ş','S')
        .replace('Ç','C').replace('Ğ','G').replace('İ','I').replace('Ö','O').replace('Ü','U')
        .replace('ç','c').replace('ğ','g').replace('ö','o').replace('ü','u').replace('ş','s').replace('Ş','S')
        .replace('Ç','C').replace('Ğ','G').replace('İ','I').replace('Ö','O').replace('Ü','U')
        .replace('ç','c').replace('ğ','g').replace('ö','o').replace('ü','u').replace('ş','s').replace('Ş','S')
        .replace('Ç','C').replace('Ğ','G').replace('İ','I').replace('Ö','O').replace('Ü','U')
        .replace('ç','c').replace('ğ','g').replace('ö','o').replace('ü','u').replace('ş','s').replace('Ş','S')
        .replace('Ç','C').replace('Ğ','G').replace('İ','I').replace('Ö','O').replace('Ü','U')
        .replace('ç','c').replace('ğ','g').replace('ö','o').replace('ü','u').replace('ş','s').replace('Ş','S')
        .replace('Ç','C').replace('Ğ','G').replace('İ','I').replace('Ö','O').replace('Ü','U')
        .replace('ç','c').replace('ğ','g').replace('ö','o').replace('ü','u').replace('ş','s');
        console.log(this.documentNumber);
        this.inventionStatus.push({status: this.status, date:Date.now(), recordigUser:this.loggedUser});
        //console.log(this.inventionStatus)
        this.userData.updateInvention(this.company,this.attorney,this.rdCenter,this.project,
          this.documentNumber,
          this.inventionName,
          this.inventionDate,
          this.inventor,
          this.inventionStatus,
          this.docLink,
          this.patentInfo,
          this.keyCode,
          this.notes
          ).
          subscribe(arr=>{
            const time=(Math.round(Date.now()/1000));
            const date = new Date(this.inventionDate);
            const unixTimestamp = Math.floor(date.getTime() / 1000);
            const reminder= [unixTimestamp, unixTimestamp+2628000,unixTimestamp+3942000, unixTimestamp+4599000 ]  // Buluş tarihinden 1 Ay, 1,5 ay, 1,75 ay sonra
            this.mailService.demandforrightReminder(this.inventionDate,this.inventionName, this.status, reminder).pipe(first())
            .subscribe((resp: any) => {
            console.log({ resp });

            alert("15 gün, 1 ay ve 1,5 ay sürelerinde karar girişinin yapılması için hatırlatma yapılacaktır")
            }, (err: any) => {
            console.error({ err });});
            //console.log(arr);
          this.error="Buluş Kaydedildi";

        alert("Buluş Kaydedildi");
        this.route.navigate(['../../'], { relativeTo: this.activatedRoute });},
          err=>{
          this.error=err.statusText;
          console.log(this.error)});
          this.users=[];

      }
      onSubmitEmail(){
        this.documentNumber=this.documentNumber.toLowerCase();
        this.inventionName=this.inventionName.toLowerCase();
        this.notes=this.notes.toLowerCase();
        const time=(Math.round((Date.now()/1000)+300)); //300 for delay
        this.visible=false;
        this.inventionStatus.push({status:"kabul edilmiş buluş", date:Date.now()});
        //console.log(this.inventionStatus)
        this.userData.updateInvention(this.company,this.attorney,this.rdCenter,this.project,
          this.documentNumber,
          this.inventionName,
          this.inventionDate,
          this.inventor,
          this.inventionStatus,
          this.docLink,
          this.patentInfo,
          this.keyCode,
          this.notes
          ).
          subscribe(arr=>{
            //console.log(arr);
          this.error="Buluş Kaydedildi";
          alert("Buluş Kaydedildi")},
          err=>{
          this.error=err.statusText;
          console.log(this.error)});
          this.users=[];
          for (var val of this.inventorData) {
            let shareText=""
            if (val.share<1) {shareText="belirtilmemiştir." } else {shareText=val.share+"/100"}
            this.mailService.sendStatusUpdate(val.name, this.inventionName, this.status, val.share,val.mail,time)
            .pipe(first())
            .subscribe(resp => {
              //console.log({ resp });
            }, err => {
              console.error({ err });
            });
          }
          this.route.navigate(['../../'], { relativeTo: this.activatedRoute });
      }
}
